module.exports = __webpack_public_path__ + "static/media/premiacao_03.a45fcda1.jpg";